
<div class="t-popup popup-patientDetails" [formGroup]="blockForm">
  <div class="t-popup-close"></div>
  <div class="t-popup-frame" style="display: flex; flex-direction:column;">
    <div class="t-popup-body">
      <button class="t-btn-popup-close" aria-label="close popup" (click)="closeBlockModal()" ></button>
      <h2> set Block details</h2>
      
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label> Block Start Date </label>
            <i class="t-sep"></i>
            <input [matDatepicker]="startBlockDate"  formControlName="blockStartDate" class="t-field-text w100"/>
            <img src="../../assets/icons/date.svg" (click)="startBlockDate.open()" style='margin-left: -1.8em;'>
            <mat-datepicker #startBlockDate  startView="year"></mat-datepicker>
          </div>
        </div>

        <!-- Hour Selection -->
        <div class="w30">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>start Hour </label>
            <i class="t-sep"></i>
            <input type="time" class="t-select w100" formControlName="startHour">
          </div>
        </div>
      </div>

      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label> Block End Date </label>
            <i class="t-sep"></i>
            <input [matDatepicker]="endBlockDate"  formControlName="blockEndDate" class="t-field-text w100"/>
            <img src="../../assets/icons/date.svg" (click)="endBlockDate.open()" style='margin-left: -1.8em;'>
            <mat-datepicker #endBlockDate  startView="year"></mat-datepicker>
          </div>
        </div>

        <!-- Hour Selection -->
        <div class="w30">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>End Hour </label>
            <i class="t-sep"></i>
            <input type="time" class="t-select w100" formControlName="endHour">
          </div>
        </div>
      </div>

      <!-- Exam Type  -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <!-- Duration -->
        <div style= "width: min-content">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>Duration</label>
            <i class="t-sep"></i>
            <input type="text" class="t-field-text w100" formControlName="duration"  />
            <span style="margin-right: 5%;" *ngIf="formattedDuration.days > 0">{{ formattedDuration.days }} days</span>
            <span style="margin-right: 5%;" *ngIf="formattedDuration.days > 0 || formattedDuration.hours > 0">{{ formattedDuration.hours }} hours</span>
            <span>{{ formattedDuration.minutes }} min</span>
          </div>
        </div>
      </div>

      <!-- Comments -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label> Comments </label>
            <textarea class="t-field-text w100" formControlName="comment"></textarea>
          </div>
        </div>
      </div>
      
      
      <div *ngIf="!event" style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
        <button class="delete_patieont" matTooltip="ביטול" (click)="closeBlockModal()" >Cancel</button>
        <button class="save_patieont" matTooltip="שמור תור" (click)="saveBlock()">Save</button>
      </div>
       <div *ngIf="event" style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
        <button class="delete_patieont" matTooltip="מחיקת חסימה" (click)="showDeleteAlert=true" >Delete</button>

        <div *ngIf="showDeleteAlert" class="t-validation-wrap">
          <button class="t-menu-item is-invalid-left"></button>
          <div class="t-validation-message-left" style="width: 20em; left: -11em; top: -1.5em; font-size: medium;">
            <span style="border-radius: 8px">
              <p style="margin-bottom: 1em;">
                Are you sure you want to delete this block?
              </p>
              <div style="display: flex; justify-content: space-between; margin-left: 1vw; margin-right: 1vw;">
                <button class="t-menu-item"  (click)="deleteBlock()">
                  Yes
                </button>
                <button class="t-menu-item" (click)="showDeleteAlert = false">
                  No
                </button>
              </div>
            </span>
          </div>
        </div>
        <button class="save_patieont" matTooltip="עדכון פרטי חסימה" (click)="updateBlock()">Close and Update</button>
      </div>
    </div>
  </div>
</div>

